module.exports = __webpack_public_path__ + "static/media/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.a765eb52.mp3";